// #2700 — score-api's listClasses (class.js) returns two fields whose value
// traces back to the show's RIDES, not to class metadata:
//   - `fvdPushState` (#567) — computed at READ TIME, aggregated over each
//     class's released rides (computePushStatesByClass).
//   - `testDisagreement` (#2251) — persisted ON the class row, but WRITTEN by
//     daysheet.js's reconcile from the class's rides' resolved test slugs
//     (computeTestDisagreement, daysheet.js:147/892), not recomputed on every
//     read. It looks like a plain stored field, which is exactly the trap
//     Jaybill's caching-constraint comment calls out by name: "even a value
//     that looks like a cheap static number." ClassManager.jsx renders it as
//     the #2252 flagged-class warning chip off `c.testDisagreement?.flagged`
//     — a stale cached flag is a false "test disagreement" warning on a
//     live-show screen.
// Per that comment (binding for the whole scoreadmin-perf workstream), ride
// data is never safe to cache — anything derived from rides goes stale the
// moment it's cached. So both are stripped before a row is written to the
// local classes cache (ClassManager.jsx); a cached row can never surface a
// stale ride-derived value, only a live fetch ever returns them.
//
// `scheduledTime` (#623) is READ-TIME-DERIVED too (applyDerivedClassTimes),
// but is deliberately NOT stripped: it falls back to the persisted
// `cls.scheduledTime` that reconcile already wrote onto the class row
// (daysheet.js:879) whenever no live ride refines it, so it is the same
// value the page already shows absent a ride update. It is also load-bearing
// class metadata elsewhere on this screen (the #591 no-scheduledTime filter,
// ClassManager.jsx:816, and day grouping, classDisplay.js's classDay/
// classDayKey) — stripping it would make every cached row invisible or
// ungroupable, not just stale. FvdPushStatusIcon already falls back to
// NOT_POSTED for "older cached data" missing fvdPushState, and
// TestDisagreementChip already renders nothing for a falsy/missing
// testDisagreement (`!testDisagreement?.flagged`), so a cached row renders
// correctly without either stripped field.
export function stripRideDerivedFields(cls) {
  // eslint-disable-next-line no-unused-vars
  const { fvdPushState, testDisagreement, ...safe } = cls;
  return safe;
}
